import PropTypes from 'prop-types';
import React from 'react';

import Classes from 'classnames';

class ModalGoogleDrivePathView extends React.Component {
    static propTypes = {
        parents: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string
            })
        ),
        onParentClick: PropTypes.func
    };

    onParentClick = (id) => {
        const {onParentClick} = this.props;
        if (onParentClick) onParentClick(id);
    };

    render() {
        const { parents } = this.props;
        const parentsCount = parents.length;

        const firstClasses = Classes("folders-path", {
            "current-folder": parentsCount === 1
        });

        return (
            <div className="path">
                <div className={firstClasses} onClick={this.onParentClick.bind(this, parents[0].id)}>{parents[0].name}</div>
                {parentsCount > 3 && <div className="folders-path">/ ...</div>}
                {parents.map((p,key)=>{
                    if (key === 0 || key < parentsCount - 2) return;

                    const pathClasses = Classes("folders-path", {
                        "current-folder": key === parentsCount - 1
                    });

                    return <div key={p.id} className={pathClasses} onClick={this.onParentClick.bind(this, p.id)}>/ {p.name}</div>
                })}
            </div>
        );
    }
}

module.exports = ModalGoogleDrivePathView;